module.exports = __webpack_public_path__ + "img/chest.d1a59d8d.png";